<template>
  <div class="c-article-filter">
    <button v-if="!isDesktop" class="c-article-filter__filter-button" type="button" @click="toggleAccordion">
      <i class="ico-filter"></i>
      絞り込む
      <span :class="['c-article-filter__accordion-icon', { isAccordionOpen }]"></span>
    </button>
    <div
      class="c-article-filter__hidden-items"
      :class="{ isAccordionOpen }"
    >
      <ul class="c-article-filter__items">
        <li
          v-for="(filter, index) in filters"
          :key="index"
          class="c-article-filter__item"
        >
          <label :for="filter.name" class="c-article-filter__label"
            >{{ filter.label }}:</label
          >
          <div class="c-article-filter__select-wrapper">
            <select
              :name="filter.name"
              :id="filter.name"
              class="c-article-filter__select"
              v-model="selectedOptions[index]"
            >
              <option value="">すべて</option>
              <option v-for="option in filter.options" :value="option">
                {{ option }}
              </option>
            </select>
          </div>
        </li>
      </ul>
      <div class="c-article-filter__button">
        <a :href="href" class="m-button">絞り込む</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentsArticleFilter',
  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isAccordionOpen: false,
      isDesktop: false,
      selectedOptions: new Array(this.filters.length).fill(''),
    }
  },
  methods: {
    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen
    },
    handleResize() {
      this.isDesktop = window.matchMedia('(min-width: 1025px)').matches
      this.isAccordionOpen = this.isAccordionOpen || this.isDesktop
    },
  },
  computed: {
    href() {
      const tagsString = this.selectedOptions
        .filter((option) => !!option)
        .join('+')
      return tagsString ? `${this.baseUrl}/tagged/${tagsString}` : this.baseUrl
    },
  },
  created() {
    // URLからタグを取得、初期値セット
    const currentPath = window.location.pathname
    const tagMatch = currentPath.match(/\/tagged\/(.+)/)
    const currentTags = tagMatch
      ? decodeURIComponent(tagMatch[1]).split('+')
      : []
    this.filters.forEach((filter, index) => {
      const selectedOption =
        filter.options.find((option) => currentTags.includes(option)) || ''
      this.selectedOptions[index] = selectedOption || ''
    })
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-article-filter {
  &__filter-button {
    align-items: center;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    width: 50%;
  }

  &__accordion-icon {
    border-bottom: 1px solid variables.$color-text;
    border-right: 1px solid variables.$color-text;
    content: '';
    height: 7px;
    transform: rotate(45deg);
    transition: transform .3s;
    width: 7px;

    &.isAccordionOpen {
      transform: rotate(225deg);
    }
  }

  &__hidden-items {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);

    &.isAccordionOpen {
      max-height: 1000px;
    }
  }

  &__items {
    margin: 20px 0;

    @include mixins.screen-desktop {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
  }

  &__item {
    align-items: center;
    display: flex;

    & + & {
      @include mixins.screen-mobile {
        margin-top: 20px;
      }
    }
  }

  &__label {
    flex-shrink: 0;
    width: 100px;
  }

  &__select-wrapper {
    background-color: #fff;
    border: 1px solid variables.$color-accent;
    border-radius: 4px;
    position: relative;
    width: 100%;

    @include mixins.screen-desktop {
      width: 200px;
    }

    &::before {
      color: variables.$color-accent;
      content: '▼';
      font-size: 14px;
      left: 10px;
      pointer-events: none;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__select {
    appearance: none;
    background: transparent;
    border: none;
    color: variables.$color-text;
    font-size: 12px;
    width: 100%;
    padding: 8px 10px 8px 30px;
  }

  &__button {
    @include mixins.screen-desktop {
      width: 120px;
    }
  }
}
</style>
